import { ArtistPortalSyncStatus } from 'fym-shared/src/smartlinks/artistPortals';
import { RawServiceConnection, ServiceConnection } from '../fymAPI.types';

/**
 * Fills the artist-portal fields a server older than this feature does not send.
 *
 * The app ships to the stores and the API deploys on its own clock, so a new
 * app can meet an old server. The defaults say "no provider here": the Connect
 * button stays hidden and nothing claims a sync ever ran.
 */
export function withArtistPortalDefaults(connection: RawServiceConnection): ServiceConnection {
  return {
    ...connection,
    authKind: connection.authKind ?? null,
    connectAvailable: connection.connectAvailable ?? false,
    artist: connection.artist ?? null,
    externalAccountEmail: connection.externalAccountEmail ?? null,
    syncStatus: connection.syncStatus ?? ArtistPortalSyncStatus.idle,
    lastSyncAt: connection.lastSyncAt ?? null,
    syncedThrough: connection.syncedThrough ?? null,
    lastSyncError: connection.lastSyncError ?? null,
    earlyAccess: connection.earlyAccess ?? false,
  };
}
